import { render } from "./V1Style.vue?vue&type=template&id=66a2a0d9&scoped=true"
import script from "./V1Style.vue?vue&type=script&lang=js"
export * from "./V1Style.vue?vue&type=script&lang=js"

import "./V1Style.vue?vue&type=style&index=0&id=66a2a0d9&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a2a0d9"]])

export default __exports__